import React, { memo, Fragment } from 'react';
import PropTypes from 'prop-types';

const PlaybackPageTemplate = (props) => {

    const {
        player,
        metadata,
        playlist,
        companionAd,
        skinAd,
    } = props;

    return (
        <Fragment>
            {skinAd}
            <div className="playback-page-template">
                <section className="playback-page-template__main-content">
                    <div className="playback-page-template__player-container">
                        {player}
                    </div>
                    <div className="playback-page-template__metadata-container">
                        {metadata}
                    </div>
                </section>
                <aside className="playback-page-template__playlist-content">
                    {companionAd}
                    {playlist}
                </aside>
            </div>
        </Fragment>
    );

};

PlaybackPageTemplate.defaultProps = {
    metadata: null,
    player: null,
    playlist: null,
    companionAd: null,
    skinAd: null,
};

PlaybackPageTemplate.propTypes = {
    metadata: PropTypes.element,
    player: PropTypes.element,
    playlist: PropTypes.element,
    companionAd: PropTypes.element,
    skinAd: PropTypes.element,
};

export default memo(PlaybackPageTemplate);
